
import Dropdown from '../Dropdown/Dropdown';
import { ContainerFilters, FilterItem } from './Filters.styles';

const Filters = ({ data: { customerSuccess, typification }, handleFilter }) => {
    return (
        <ContainerFilters>
            <div className="title">Filtrar por:</div>
            {customerSuccess.length > 0 ?
                <FilterItem>
                    <Dropdown
                        arraySelect={[{ value: 0, label: 'Sin Asignación' }, ...customerSuccess]}
                        colorSelect={'blue'}
                        isDisabled={false}
                        nullMessage="Asignación"
                        onChangeSelect={(e) => handleFilter({ assigned: e })}
                        clearSelect
                    />
                </FilterItem> : null
            }
            {typification.length > 0 ?
                <FilterItem>
                    <Dropdown
                        arraySelect={typification}
                        colorSelect={'grey'}
                        isDisabled={false}
                        nullMessage="Tipificación"
                        onChangeSelect={(e) => handleFilter({ typification: e })}
                        clearSelect
                    />
                </FilterItem> : null
            }

        </ContainerFilters>
    );
};

export default Filters;
